<ng-container *ngIf="selectedDistributionGroup$ | async as group">
    <div class="header__distribution-group">
        <span class="font-5 uppercase"><i class="fas fa-info-circle exclamation-color"></i>&nbsp;Placing Orders on Behalf of</span>
        <span class="font-5 uppercase font-weight-bold text-truncate distribution-group-name">{{group.label}}</span>
    </div>
</ng-container>
